import { Component } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Store } from '@ngxs/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { SamwinLinesStateSelector } from 'src/app/store/samwin/samwin-lines/samwin-lines.selector';
import { IShortCallInfo } from 'src/app/store/samwin/samwin-lines/samwin-lines.state';

@Component({ template: '' })
export abstract class CallingToastBaseComponent extends Toast {
   public currentCallShortInfo$: Observable<IShortCallInfo>;

   public answerIcon: IconDefinition = WellKnownIconsEnum.CALLING_ANSWER.icon;
   public declineIcon: IconDefinition = WellKnownIconsEnum.CALLING_HANGUP.icon;
   public cancelIcon: IconDefinition = WellKnownIconsEnum.CANCEL.icon;

   constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, protected store: Store) {
      super(toastrService, toastPackage);
      this.currentCallShortInfo$ = store.select(SamwinLinesStateSelector.getCurrentCallShortInfo);
   }

   action(event: Event) {
      event.stopPropagation();
      return false;
   }
}
